import report2018 from './freelance-economy-2018.pdf';
import report2019 from './freelance-economy-2019.pdf';
import report2020 from './freelance-economy-2020.pdf';
import report2021 from './freelance-economy-2021.pdf';
import report2022 from './freelance-economy-2022.pdf';
import report2023 from './freelance-economy-2023.pdf';
import report2024 from './freelance-economy-2024.pdf';
import report2025 from './freelance-economy-2025.pdf';

export const REPORTS = {
    2018: report2018,
    2019: report2019,
    2020: report2020,
    2021: report2021,
    2022: report2022,
    2023: report2023,
    2024: report2024,
    2025: report2025,
};

export function getLastReportYear() {
    const keys = Object.keys(REPORTS);
    return keys[keys.length - 1];
}
